module.exports = __webpack_public_path__ + "static/img/mechanism-of-action-2.1226250a.png";